// extracted by mini-css-extract-plugin
export default {"outerDiv":"AlertBox_outerDiv__icS-W","innerDiv":"AlertBox_innerDiv__QudiM","green":"AlertBox_green__OzdtN","imgBox":"AlertBox_imgBox__ZYqgO","img":"AlertBox_img__6PBKG"};